import type { ButtonHTMLAttributes } from "react";

export function GradientButton({
  className = "",
  children,
  disabled,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-medium text-white transition-[transform,background-color] duration-150 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-40 ${
        disabled
          ? "glass-strong text-[var(--text-muted)]"
          : "shadow-[var(--glow-accent)] bg-[var(--cta)] hover:bg-[var(--cta-hover)]"
      } ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
